module.exports = __webpack_public_path__ + "img/24.544af138.jpg";